exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tips-and-guide {\n  width: 300px;\n  height: 865.5px;\n  border: 1px solid lightgray;\n  margin-right: 10px;\n  display: flex;\n  flex-direction: column;\n}\n\n.tips-and-guide-title {\n  box-sizing: border-box;\n  height: 36px;\n  background-color: #3b4e61;\n  padding: 6px;\n  margin-bottom: 8px;\n  color: white;\n  font-weight: bold;\n}\n\n.fa-question-circle {\n  margin-right: 6px;\n}\n\n.tips-and-guide-content {\n  box-sizing: border-box;\n  height: fit-content;\n  background-color: #3b4e61;\n  padding: 6px;\n  margin-bottom: 8px;\n  color: white;\n  font-weight: bold;\n}", ""]);

// exports
